import { jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        d: "M20.483 7.693c-.114.088-2.127 1.221-2.127 3.74 0 2.914 2.561 3.945 2.638 3.97-.012.063-.407 1.412-1.35 2.786-.842 1.21-1.72 2.417-3.057 2.417s-1.68-.775-3.224-.775c-1.503 0-2.038.8-3.26.8-1.223 0-2.076-1.118-3.057-2.493-1.136-1.614-2.054-4.12-2.054-6.5 0-3.817 2.484-5.841 4.93-5.841 1.299 0 2.382.852 3.198.852.776 0 1.987-.904 3.465-.904.56 0 2.573.052 3.898 1.948m-4.6-3.563c.611-.725 1.044-1.73 1.044-2.735 0-.14-.012-.281-.037-.395-.995.037-2.178.662-2.892 1.488-.56.636-1.083 1.642-1.083 2.66 0 .154.026.307.037.356.063.012.165.025.268.025.892 0 2.015-.596 2.663-1.4"
      }
    )
  }
);
export {
  t as default
};
